/**
 * Pound sterling.
 */
export var GBP = {
  code: 'GBP',
  base: 10,
  exponent: 2
};